import { File as FileIcon } from 'lucide-react'
import cn from 'classnames'

import { analytics } from 'utils/analytics'
import Text from './typography/Text'

export interface Props {
  text: string
  isSelected?: boolean
  onClick?: () => void
}

function FileButtonPlayground({
  text,
  isSelected,
  onClick,
}: Props) {

  function handleClick() {
    onClick?.()
    analytics.track('editor file tab selected', { file: text })
  }

  return (
    <button
      className={cn(
        'p-1',
        'border',
        'border-gray-300',
        'rounded-md',
        'justify-center',
        { 'hover:bg-white': !isSelected },
        { 'bg-transparent': !isSelected },
        { 'bg-white': isSelected },
        'group',
      )}
      onClick={handleClick}
    >
      <div
        className="
          flex
          items-center
          space-x-1
        "
      >
        <FileIcon
          className={cn(
            { 'text-gray-800': isSelected },
            { 'text-gray-500': !isSelected },
            { 'group-hover:text-gray-700': !isSelected },
            'transition-all',
            'duration-75',
          )}
          size={12}
        />
        <Text
          className="
            transition-all
            duration-75,
          "
          color={cn(
            { 'text-gray-800': isSelected },
            { 'text-gray-500': !isSelected },
          )}
          hoverColor={`${!isSelected ? 'group-hover:text-gray-700' : ''}`}
          size={Text.size.sm}
          text={text}
        />
      </div>
    </button>
  )
}

export default FileButtonPlayground
